import React from 'react';

/**
 * Error Boundary component to catch React component errors
 * Suppresses network errors from triggering the error boundary
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Suppress network errors in error boundary
    if (error?.isNetworkError || 
        error?.suppressErrorOverlay ||
        (error?.message === 'Network Error' && !error?.response) ||
        error?.code === 'ERR_NETWORK' ||
        error?.code === 'ECONNREFUSED' ||
        error?.message?.includes('Failed to fetch')) {
      return null; // Don't trigger error boundary for network errors
    }
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Suppress network errors
    if (error?.isNetworkError || 
        error?.suppressErrorOverlay ||
        (error?.message === 'Network Error' && !error?.response) ||
        error?.code === 'ERR_NETWORK' ||
        error?.code === 'ECONNREFUSED' ||
        error?.message?.includes('Failed to fetch')) {
      return;
    }
    
    // Log non-network errors
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({
      errorInfo: errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ 
          padding: '40px', 
          textAlign: 'center',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'var(--surface-sunken)'
        }}>
          <h2 style={{ color: 'var(--feedback-error)', marginBottom: '16px' }}>
            Something went wrong
          </h2>
          <p style={{ color: 'var(--text-muted)', marginBottom: '24px', maxWidth: '500px' }}>
            {this.state.error?.message || 'An unexpected error occurred'}
          </p>
          <button 
            onClick={() => {
              this.setState({ hasError: false, error: null, errorInfo: null });
              window.location.reload();
            }}
            style={{
              padding: '8px 16px',
              backgroundColor: 'var(--brand-primary)',
              color: 'var(--text-on-brand)',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '13px', fontWeight: 500
            }}
          >
            Reload Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;



